<template>
    <div>
         <!-- main-area -->
         <main class="fix">
                <!-- breadcrumb-area -->
                <section class="breadcrumb__area breadcrumb__bg ">
                    <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
    
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="breadcrumb__content">
                                    <h2 class="title">Berita</h2>
                                    <nav aria-label="breadcrumb">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a href="index.html">Beranda</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">Berita</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="breadcrumb__shape">
                        <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                    </div>
                </section>
                <!-- breadcrumb-area-end -->
                <!-- blog-area -->
                <section class="blog__area">
                    <div class="container">
                        <div class="blog__inner-wrap">
                            <div class="row">
                                <div class="col-70">
                                    <div class="blog-post-wrap">
                                        
                                        <!-- <div class="row gutter-24">
    
                                             <div class="col-md-6" v-for="data in list_data" :key="data.id">
                                                 <div class="blog__post-two shine-animate-item">
                                                        <div class="blog__post-thumb-two">
                                                            <a @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul" > <img :src="file_path+data.foto" alt="" class="shine-animate"></a>
                                                        </div>
                                                    <div class="blog__post-content-two">
                                                                <div class="blog-post-meta">
                                                                    <div class="blog-avatar">
                                                                        <div class="avatar-content">
                                                                            <p>By <a href="javascript:void(0)">{{ data.createBy.toLowerCase() }} </a> &nbsp;
                                                                            <i class="fas fa-calendar-alt"></i> {{convert_tgl(data.createAt)}}
                                                                            </p>
                                                                        </div>
                                                                        
                                                                    </div>
                                                                </div>
                                                                <h2 class="title"><a @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul" >{{data.judul}}</a></h2>
                                            
                                                        </div>
                                                </div>
                                            </div>
                                           
                                        </div> -->
    
    
    
    
    
                                        <div class="row gutter-24">
                                            <div class="col-md-6" v-for="data in list_data" :key="data.id">
                                                <div class="blog-post-item blog__post-three shine-animate-item">
                                                    <div class="blog-post-thumb blog__post-thumb-three">
                                                        <a  @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul"  class="shine-animate"><img :src="file_path+data.foto" alt="Apexa" /></a>
                                                    </div>
                                                    <div class="blog-post-content blog__post-content-three">
                                                        <a href="javascript:void(0);" class="post-tag">{{data.kategori_id}}</a>
                                                        <h2 class="title">
                                                            <a  @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul" ><span>{{ truncateText(data.judul, 80) }}</span></a>
                                                            </h2>
    
    
                                                        <!-- <div class="blog-post-meta mb-20">
                                                            <ul class="list-wrap">
                                                                <li><i class="fas fa-calendar-alt"></i>{{convert_tgl(data.createAt)}}</li>
                                                                
                                                            </ul>
                                                        </div> -->
    
                                                        <div class="blog-post-meta">
                                                                    <div class="blog-avatar">
                                                                        <div class="avatar-content">
                                                                            <p>By <a href="javascript:void(0)">{{ data.createBy?.toLowerCase?.() || 'Admin' }}</a> &nbsp;
                                                                            <i class="fas fa-calendar-alt"></i> {{convert_tgl(data.createAt)}}
                                                                            </p>
                                                                        </div>
                                                                        
                                                                    </div>
                                                                </div>
                                                        <!-- <a @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul"  class="btn">Baca Selengkapnya</a> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
    
                                        <div class="pagination-wrap mt-40">
                                            <nav aria-label="Page navigation example">
                                                <ul class="pagination list-wrap">
                                                <li class="page-item" :class="{ disabled: page_first === 1 }">
                                                    <a class="page-link" href="#" @click.prevent="btn_prev"><i class="fas fa-angle-double-left"></i></a>
                                                </li>
                                                <li
                                                    class="page-item"
                                                    v-for="page in page_last"
                                                    :key="page"
                                                    :class="{ active: page === page_first }"
                                                >
                                                    <a class="page-link" href="#" @click.prevent="go_to_page(page)">{{ page }}</a>
                                                </li>
                                                <li class="page-item" :class="{ disabled: page_first === page_last }">
                                                    <a class="page-link" href="#" @click.prevent="btn_next"><i class="fas fa-angle-double-right"></i></a>
                                                </li>
                                                </ul>
                                            </nav>
                                        </div>
    
    
                                    </div>
                                </div>
                                <div class="col-30">
                                    <aside class="blog__sidebar">
                                        <div class="sidebar__widget sidebar__widget-two">
                                            <div class="sidebar__search">
                                                <form @submit.prevent>
                                                    <input type="text" placeholder="Cari Berita . . ." name="search" id="wid-search" value="" v-model="cari_value" @keyup="cari_data()" @keyup.enter.prevent="cari_data">
                                                    <button type="submit">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                                            <path d="M19.0002 19.0002L14.6572 14.6572M14.6572 14.6572C15.4001 13.9143 15.9894 13.0324 16.3914 12.0618C16.7935 11.0911 17.0004 10.0508 17.0004 9.00021C17.0004 7.9496 16.7935 6.90929 16.3914 5.93866C15.9894 4.96803 15.4001 4.08609 14.6572 3.34321C13.9143 2.60032 13.0324 2.01103 12.0618 1.60898C11.0911 1.20693 10.0508 1 9.00021 1C7.9496 1 6.90929 1.20693 5.93866 1.60898C4.96803 2.01103 4.08609 2.60032 3.34321 3.34321C1.84288 4.84354 1 6.87842 1 9.00021C1 11.122 1.84288 13.1569 3.34321 14.6572C4.84354 16.1575 6.87842 17.0004 9.00021 17.0004C11.122 17.0004 13.1569 16.1575 14.6572 14.6572Z" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                        
    
    
                                        <div class="sidebar__widget">
                                            <h4 class="sidebar__widget-title">Berita Terbaru</h4>
                                            <div class="sidebar__post-list">
    
    
                                                <div class="sidebar__post-item" v-for="data in list_berita" :key="data.id">
                                                    <div class="sidebar__post-thumb">
                                                        <a class="shine-animate" @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul"><img :src="file_path+data.foto" alt="" height="60px" weight="50px"></a>
                                                    </div>
                                                    <div class="sidebar__post-content">
                                                        <h5 class="title"><a @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul">{{ truncateText(data.judul, 30) }}</a></h5>
                                                        <span class="date"><i class="flaticon-time"></i>{{convert_tgl(data.createAt)}}</span>
                                                    </div>
                                                </div>
    
    
                                            </div>
                                        </div>
    
    
    
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- blog-area-end -->
                
            </main>
            <!-- main-area-end -->
    
    
    </div>
    </template>
    
    <script>
    
    
        export default {
    
            data() {
                return {
                    data_load : false,
                    form : {
                        id : '',
                        judul : '',
                        sumber : '',
                        deskripsi : '',
                        isi : '',
                        foto : '',
                        unit_kerja : '',
                        status : '',
                        keterangan : '',
                        createBy : '',
                        createAt : '',
                    },
    
    
                    id :'',
                    cek_load_data : true,
                    file_old: "",
                    file_path: this.$store.state.URL_APP + "uploads/",
    
                    // unit_kerja: UNIT_KERJA,
           
                    list_data: [],
                    list_berita: [],
                    page_first: 1,  
                    page_last: 0,
                    cari_value: "",
                    unit_kerja: this.$store.state.UNIT_KERJA
                }
            },
            methods: {
                truncateText(text, limit = 50) {
                    if (!text) return '';
                    return text.length > limit ? text.substring(0, limit) + '...' : text;
                },
                getView: function() {
                    this.cek_load_data = true;
                    fetch(this.$store.state.ADD_URL_BERITA + "viewOPD", {
                        method: "POST",
                        headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                        },
                            body: JSON.stringify({
                            data_ke: this.page_first,
                            cari_value: this.cari_value,
                            unit_kerja : this.unit_kerja
                        })
                    })
                        .then(res => res.json())
                        .then(res_data => {
                            console.log("HASIL BERITA:", res_data); // Tambahkan ini
                            this.list_data = res_data.data;
                            this.page_last = res_data.jml_data
    
                            this.cek_load_data = false;
                            // console.log(res_data);
                    });
                },
    
                getListBerita: function() {
                    this.cek_load_data_list = true;
                    fetch(this.$store.state.ADD_URL_BERITA+"homeOPD", {
                        method: "POST",
                        headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                        },
                        body: JSON.stringify({
                        unit_kerja: this.unit_kerja,
                            
                        })
                    })
                        .then(res => res.json())
                        .then(res_data => {
                            this.list_berita = res_data;
                            // this.cek_load_data = false;
                            // console.log(res_data);
                    });
                },
                push_berita : function(id){
                    this.$router.push('/isi_berita?id='+id);
                },
    
    
                // ================== PAGINASI ====================
                    alertku: function(type, title) {
                    this.$swal({
                        type: type,
                        title: title,
                        showConfirmButton: false,
                        timer: 800
                    });
                    },
    
                    // btn_prev : function(){
                    //         this.cek_load_data = true;
                    //     if(this.page_first>1){
                    //         this.page_first--
                    //     }else{
                    //         this.page_first = 1;
                    //     }
                    //     this.getView();
                    // },
    
                    // btn_next : function(){
                        
                    //     if(this.page_first >= this.page_last){
                    //         this.page_first == this.page_last
                    //     }else{
                    //         this.page_first++;
                    //     }
                    //     this.getView();
                    // },
    
                    btn_prev() {
                    if (this.page_first > 1) {
                        this.page_first--;
                        this.getView();
                    }
                    },
                    btn_next() {
                    if (this.page_first < this.page_last) {
                        this.page_first++;
                        this.getView();
                    }
                    },
    
                    go_to_page(page) {
                        this.page_first = page;
                        this.getView(); // atau nama method Anda untuk fetch data
                    },
    
                    cari_data() {
                        this.page_first = 1;
                        this.getView();
                    },
                    onFileSelected: function(event) {
                    this.form.file = event.target.files[0];
                    },
                    convert_tgl: function(dateString) {
                        var date = new Date(dateString);
                        var getBulan = date.getMonth() + 1; var bulan = '';
                        if (getBulan == '1') {bulan = 'Jan'} 
                        else if(getBulan == '2') {bulan = 'Feb'}
                        else if(getBulan == '3') {bulan = 'Mar'}
                        else if(getBulan == '4') {bulan = 'Apr'}
                        else if(getBulan == '5') {bulan = 'Mei'}
                        else if(getBulan == '6') {bulan = 'Jun'}
                        else if(getBulan == '7') {bulan = 'Jul'}
                        else if(getBulan == '8') {bulan = 'Agt'}
                        else if(getBulan == '9') {bulan = 'Sep'}
                        else if(getBulan == '10') {bulan = 'Okt'}
                        else if(getBulan == '11') {bulan = 'Nov'}
                        else if(getBulan == '12') {bulan = 'Des'}
    
    
    
                        return date.getDate() + " " + bulan + " " + date.getFullYear();
                        // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
                    }
                // ================== PAGINASI ====================
    
    
    
    
            },
            mounted() {
                
                this.getView();
                this.getListBerita();
    
            },
    
        }
    </script>
    